import { ConversationSummary } from '@shared/services/chat.service';

export type ConversationGroupKey = 'today' | 'yesterday' | 'week' | 'older';

export interface ConversationGroup {
  key: ConversationGroupKey;
  conversations: ConversationSummary[];
}

const DAY_MS = 86_400_000;

/** Buckets the (already newest-first) history list by the viewer's own local calendar day, not
 * UTC, so "today" matches what the employee's clock says. Order inside and across groups is kept. */
export function groupConversations(conversations: ConversationSummary[], now: Date = new Date()): ConversationGroup[] {
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  const groups: ConversationGroup[] = [];
  for (const conversation of conversations) {
    const at = Date.parse(conversation.lastActivityAt);
    const key: ConversationGroupKey =
      at >= startOfToday ? 'today'
        : at >= startOfToday - DAY_MS ? 'yesterday'
          : at >= startOfToday - 7 * DAY_MS ? 'week'
            : 'older';
    const last = groups.at(-1);
    if (last?.key === key) {
      last.conversations.push(conversation);
    } else {
      groups.push({ key, conversations: [conversation] });
    }
  }
  return groups;
}
